module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "firstparagraph"
  }, [_vm._v("‘The serious questions that "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Followers ")]), _vm._v("poses about love, faith and responsibility blend with Wait’s propulsive plotting and the complicity she creates through the power of her writing to form a great surging shout of a novel, which left me, in the end, in tears. Without wanting to proselytize, I’d urge you to buy it.’")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("—"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Guardian")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }, [_c('em', {
    staticClass: "italic"
  })]), _vm._v(" "), _c('p', {
    staticClass: "firstparagraph"
  }, [_vm._v("‘Confident . . . beguiling . . . maintains tension until the last paragraph . . . The tenderness and the transformative nature of the ending—one which acknowledges the danger of wanting to belong—are truly moving.’ ")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("—"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Independent")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "firstparagraph"
  }, [_vm._v("‘The novel has a brooding tension that threatens no good to come, building to a page-turning finish.’")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("—"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Daily Mail")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "firstparagraph"
  }, [_vm._v("‘Gripping . . . devastating . . . hopeful . . . shocking.’")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("—"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Daily Express")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "firstparagraph"
  }, [_vm._v("‘A fascinating book about faith and love.’")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("—"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Prima")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "firstparagraph"
  }, [_vm._v("‘A powerful book . . . a novel unafraid to tackle difficult topics which examines charisma and hurt and how they can warp relationships. It is about power, faith and love used for good and bad ends, despair and the possibilities of redemption . . . a haunting and beautifully wrought novel with characters and a story that will stay with you long after you have closed the book itself.’")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("—"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("We Love This Book")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }, [_c('em', {
    staticClass: "italic"
  })]), _vm._v(" "), _c('p', {
    staticClass: "firstparagraph"
  }, [_vm._v("‘I really enjoyed this quietly terrifying and suspenseful exploration of obedience to authority and the dangers of fundamentalism.’")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("—Carys Bray, author of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("A Song for Issy Bradley")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "firstparagraph"
  }, [_vm._v("‘Such a suspenseful and compassionate book, never more so than in its feeling for certain characters, the disorderliness of their inner lives, their vulnerability. I thought it remarkable.’")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("—Sunjeev Sahota, Man Booker Prize-shortlisted "), _c('br'), _vm._v("author of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Year of the Runaways")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "firstparagraph"
  }, [_vm._v("‘Rebecca Wait describes the world of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Followers")]), _vm._v(" with such vividness that I dreamt about her cold, misty moorland, and with such tenderness that the ending brought tears to my eyes.’")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("—Alison Moore, Man Booker Prize-shortlisted "), _c('br'), _vm._v("author of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Lighthouse")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "firstparagraph"
  }, [_vm._v("‘A gripping tale of a violent sect in a flooded land, awaiting the end of the world, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Followers")]), _vm._v(" is also a beautifully moving story of the limits of faith and the power of family, those we make and those we choose. It will stay with me for a long time.’")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("—Peggy Riley, author of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Amity and Sorrow")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "firstparagraph"
  }, [_vm._v("‘"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Followers")]), _vm._v(" is a highly affecting and beautiful novel, both tender and brutal. It’s a poignant examination of power, faith and family, and a story that stays with you long after you turn the last page.’")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("—Nicci Cloke, author of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Lay Me Down")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "firstparagraph"
  }, [_vm._v("‘Rebecca Wait’s new novel explores the deep nature of human nature, introduces us to fascinating characters, and takes us on an unforgettable personal journey. Make time to be fully absorbed.’")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("—Philip Zimbardo, author of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Lucifer Effect")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "firstparagraph"
  }, [_vm._v("‘"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Followers")]), _vm._v(" is a powerful book. Told with great subtlety and insight, it takes us to the far reaches of human experience to reveal the seams that bind together faith, logic, understanding and our sense of self—and shows how easily a psyche can be ripped apart. Rebecca Wait’s writing has beauty, steel, economy and winning flashes of humour, and her plot is gripping. I was a convert from the very first page.’")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("—Ann Morgan, author of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Beside Myself")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "firstparagraph"
  }, [_vm._v("‘Touching, sensitive and surprisingly humorous . . . a timely reminder of what can happen to us “ordinary” people if we give up on our abilities to think and act for ourselves.’")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("—Louise Walters, author of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Mrs. Sinclair’s Suitcase")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "firstparagraph"
  }, [_vm._v("‘A sense of foreboding hovers over Rebecca Wait’s brilliant new novel, building to a terrifying conclusion. It’s a book to tear through, to horrify you, and to share with everyone you know.’")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("—Emma Chapman, author of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("How To Be A Good Wife")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "firstparagraph"
  }, [_vm._v("‘A moving, assured and intelligent novel.’")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("—Jim Crace, author of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Harvest")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "firstparagraph"
  }, [_vm._v("‘This book is a restrained tour-de-force, a profoundly unsettling, brilliantly executed, and deeply humane depiction of a slow slide toward an unspeakable act, and the difficulty and necessity of finding a way to live in the aftermath. This is a remarkable novel.’")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("—Emily St. John Mandel, author of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Station Eleven")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ae6b0e7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/thefollowers_00000.vue
// module id = 60
// module chunks = 0